import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import { useAppSelector, workspaceSelector } from '@/store';
import type { IWorkspace } from '@/types/Workspace';

export function ProgramSelect({ workspaces }: { workspaces: IWorkspace[] }) {
  const { setValue } = useFormContext();
  const { currentWorkspace } = useAppSelector(workspaceSelector);

  useEffect(() => {
    if (currentWorkspace?.id) {
      setValue('program', {
        label: currentWorkspace.name,
        value: currentWorkspace.id,
      });
    }
  }, [currentWorkspace, setValue]);

  return (
    <HookReactSingleSelect
      id='program'
      options={workspaces?.map((workspace) => ({
        label: workspace.name,
        value: workspace.id,
      }))}
      placeholder='Select Program'
      name='program'
      label='Program'
    />
  );
}
